
import { getMetadataProperties, CreateMetadataUrl } from '../util/HelpfulFunctions';
import SessionManager, { secureApiCall } from "./SessionManager";
import Configuration from "./Configuration";
import Axios from "axios";

var enCoreMetadataCache = { Entities: {}, Enums: {} };
class MetadataManager {

    static async getEntity(_entityName) {

        if (enCoreMetadataCache.Entities.hasOwnProperty(_entityName)) {
            return enCoreMetadataCache.Entities[_entityName];
        }
            
        var entityMetadata = await secureApiCall(loadEntityMetadata, _entityName);
        return entityMetadata;
    }

    static async getEnum(_enumName) {

        if (enCoreMetadataCache.Enums.hasOwnProperty(_enumName))
        {
            return enCoreMetadataCache.Enums[_enumName];
        }

        var enumMetadata = await secureApiCall(loadEnumMetadata, _enumName);
        return enumMetadata;
    }

    }


async function loadEntityMetadata(_entityName) {

    const url = CreateMetadataUrl(
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version,
        /* entityName */            _entityName,
        /* authenticationToken */   SessionManager.userToken,
        /* username */              SessionManager.userName);

    var response = await Axios.get(url);

    if (response.data) {

        var data;
        if (typeof response.data === "string") {
            data = JSON.parse(response.data);
        }
        else {
            data = response.data;
        }

        enCoreMetadataCache.Entities[_entityName] = data;
        return data;
        
    }
    else
        return null;

}

async function loadEnumMetadata(_enumName) {

    if (!_enumName)
        return null;

    var typeInfo = getNamespaceAndType(_enumName);
    

    const url = CreateEnumMetadataUrl(
        /* connectionName */        Configuration.connectionName,
        /* version */               Configuration.version,
        /* nameSpace */             typeInfo.nameSpace,
        /* entityName */            typeInfo.typeName,
        /* authenticationToken */   SessionManager.userToken,
        /* username */              SessionManager.userName
    );

    try {
        var response = await Axios.get(url);

        if (response.data) {

            var data;
            if (typeof response.data === "string") {
                data = JSON.parse(response.data);
            }
            else {
                data = response.data;
            }

            data.findByName = function (_name) {
                for (var ix in this.Items) {
                    if (this.Items[ix].Name === _name)
                        return this.Items[ix];
                }

                return null;
            }

            enCoreMetadataCache.Enums[_enumName] = data;
            return data;
            
        }
    }
    catch (error) {
        console.log(error);
    }

    return null;
}

function CreateEnumMetadataUrl(_connectionName, _version, _nameSpace, _enumName, _authenticationToken, _username) {
    let url = Configuration.serviceUrl + 'data/' + _connectionName + '/' + _version + '/EnumMetadata';

    url = url + '/' + _enumName + '?';

    url = `${url}nameSpace=${_nameSpace}&authenticationToken=${_authenticationToken}&username=${_username}`;

    return url;
}

function getNamespaceAndType(_fullyQualifiedName) {
    
    var nameParts = _fullyQualifiedName.split(".");
    var typeName = nameParts[nameParts.length - 1];
    
    var nameSpace = '';
    if (nameParts.length > 1) {
        nameSpace = _fullyQualifiedName.substr(0, _fullyQualifiedName.length - typeName.length - 1);
    }

    return {nameSpace: nameSpace, typeName: typeName};
}

export default MetadataManager;